import {css, view, Icon, Tooltip} from '@sail/ui/deprecated';
import {info, warningCircle} from '@sail/icons/react/Icon';
import {defineMessages, FormattedMessage} from 'react-intl';
import {useState} from 'react';
import {useAnalytics} from '@stripe-internal/inline-data';
import {aiDisclaimerShownEvent} from '../analytics';

const messages = defineMessages({
  aiDisclaimer: {
    id: 'mse_inline_data.universal_help_live_answers_response.support_ai_header.ai_disclaimer',
    description:
      'Disclaimer that response was generated by AI and as such may be incorrect or misleading',
    defaultMessage:
      'These answers are generated using artificial intelligence. This is an experimental technology, and information may occasionally be incorrect or misleading.',
  },
  ai_assistant: {
    id: 'mse_inline_data.universal_help_live_answers_response.support_ai_header.ai_assistant',
    description: '"AI Assistant" in name of live answers response header',
    defaultMessage: 'AI Assistant',
  },
});

// If the tooltip is displayed for over 750ms then an analytics event is triggered for the exposure.
const TOOLTIP_DISPLAY_MS_FOR_ANALYTICS = 750;

const SupportAITooltip = () => {
  const analytics = useAnalytics();
  const [mouseoverStart, setMouseoverStart] = useState<Date | undefined>(
    undefined,
  );
  return (
    <Tooltip
      type="description"
      trigger={
        <Icon
          icon={info}
          aria-label="AI disclaimer"
          size="xsmall"
          css={{
            // The icon is one pixel too high for alignment with the text by default,
            // even in a flexbox layout with alignment on the baseline.
            // Since `align-items: baseline` doesn't actually change anything when
            // it likely should (maybe a Sail bug?), we've set `align-items: center`
            // and then explicitly added a 1 pixel padding to the top via relative
            // positioning (note that using `padding` or `margin` explicitly would
            // cause the size of the parent div to expand and pushe the text down)
            position: css.value('relative'),
            top: css.value('1px'),
            color: 'secondary',
          }}
          onMouseOver={() => setMouseoverStart(() => new Date())}
          onMouseOut={() => {
            const now = new Date().getTime();
            if (
              mouseoverStart &&
              now - mouseoverStart.getTime() > TOOLTIP_DISPLAY_MS_FOR_ANALYTICS
            ) {
              analytics.viewed(aiDisclaimerShownEvent, {
                live_answers_ai_tooltip_display_ms:
                  now - mouseoverStart.getTime(),
              });
              setMouseoverStart(undefined);
            }
          }}
        />
      }
      css={{
        stack: 'x',
        gap: 'small',
      }}
    >
      <view.div css={{paddingTop: 'xsmall'}}>
        <Icon icon={warningCircle} size="small" />
      </view.div>
      <FormattedMessage {...messages.aiDisclaimer} />
    </Tooltip>
  );
};

export const SupportAIHeader = () => {
  return (
    <view.div
      css={{
        layout: 'row',
        gap: 'xsmall',
        alignItems: css.value('center'),
      }}
    >
      <view.div>
        <view.span
          css={{
            font: 'bodyEmphasized',
          }}
        >
          <FormattedMessage {...messages.ai_assistant} />
        </view.span>
      </view.div>
      <view.div>
        <SupportAITooltip />
      </view.div>
    </view.div>
  );
};
